import { LogoMark, Stack, Text } from "@wearewqa/wqa-design-system";
import React from "react";

export function SignInHeader() {
  return (
    <Stack align="center">
      <LogoMark variant={"secondary-light"} size={48} />
      <Stack align="center" spacing="xs">
        <Text
          element="h1"
          size="displaySm"
          weight="semiBold"
          color="brand.primary.900"
        >
          Log in to your account
        </Text>
        <Text element="p" color="brand.primary.400">
          Welcome back! please enter your details
        </Text>
      </Stack>
    </Stack>
  );
}
